// extracted by mini-css-extract-plugin
export default {"langSelect":"styles_langSelect__qaHv+","isUp":"styles_isUp__73gp+"};